export type CarouselSlide = {
  /** Plain part of the headline (white). */
  lead: string
  /** Emphasised part of the headline (optic yellow). */
  accent: string
  /** Page image URL; empty string shows a placeholder to upload into. */
  image: string
  imageLabel: string
  caption: string
  /** Sheet tilt in degrees. */
  tilt: number
}

/** "The Softball Coach's Playbook – Volume 5: Shut Down the Inning" · 5-card carousel (4:5). */
export const vol5Slides: CarouselSlide[] = [
  {
    lead: 'Know who cuts.',
    accent: 'Every throw.',
    image:
      'https://cdn.magicpatterns.com/uploads/5wmT14p9HRkQBHhKUMJrMi/vol5_p22.png',
    imageLabel: 'The Cutoff Map – page 22',
    caption: 'The cutoff map your whole team can follow',
    tilt: -2.5,
  },
  {
    lead: 'No more empty bags',
    accent: 'on a bunt',
    image:
      'https://cdn.magicpatterns.com/uploads/syYU5TnNpKZMtzJKF7Edjh/vol5_p24.png',
    imageLabel: 'Bunt Coverage – page 24',
    caption: 'Who charges, who covers, where the throw goes',
    tilt: 2.5,
  },
  {
    lead: 'A 90-min team defense practice,',
    accent: 'ready to run',
    image:
      'https://cdn.magicpatterns.com/uploads/8a3KQBzkaovSTm3YGEzq1g/vol5_p28.png',
    imageLabel: 'Ready-to-Run Team Defense Practice – page 28',
    caption: 'Four blocks. Print it and coach it tonight.',
    tilt: -2,
  },
  {
    lead: 'Play in or play back?',
    accent: 'Decide before the pitch',
    image:
      'https://cdn.magicpatterns.com/uploads/giAfHtcUU4ULFP3Wgdiu8U/vol5_p33.png',
    imageLabel: 'Defense with Runners on 2nd & 3rd – page 33',
    caption: 'The situations that decide close games',
    tilt: 2,
  },
  {
    lead: 'Clip it to',
    accent: 'your board',
    image:
      'https://cdn.magicpatterns.com/uploads/7MxcSuYBTPcZGvsaizq3Yh/vol5_p50.png',
    imageLabel: 'Volume 5 Field Card – page 50',
    caption: 'Printable field card included',
    tilt: -2.5,
  },
]
